export default __webpack_public_path__ + "static/media/live_classes.47d58a8e.png";